// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailEmailContact {
    static getAttributeTypeMap() {
        return EmailEmailContact.attributeTypeMap;
    }
}
EmailEmailContact.discriminator = undefined;
EmailEmailContact.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "emailAddress",
        "baseName": "emailAddress",
        "type": "string"
    }
];
//# sourceMappingURL=emailEmailContact.js.map